export default __webpack_public_path__ + "static/media/handprint-12-13-page.ffd6f357.png";